import API from '../AxiosInstance';

export default {
  getLabels: function(podID) {
    return API.get('pods/'+podID+'/labels');
  },

  createLabel: function(podID, payload) {
    return API.post('pods/'+ podID+'/labels', payload);
  },

  updateLabel: function(podID, labelID, payload) {
    return API.patch('pods/' + podID + '/labels/' + labelID, payload);
  },

  deleteLabel: function(podID, labelID) {
    return API.delete('pods/' + podID + '/labels/' + labelID);
  },

  getMlLabels: function(podID) {
    return API.get('pods/'+podID+'/mllabels');
  },

  updateMlLabel: function(podID, labelID, payload) {
    return API.patch('pods/' + podID + '/mllabels/' + labelID, payload);
  },

  deleteMlLabel: function(podID, labelID) {
    return API.delete('pods/' + podID + '/mllabels/' + labelID);
  },

  createManyLabels: function (data) {
    return API.post('pods/labels', { podids: data.podids, labels: data.labels });
  },

  createLabelsForPodsAndNodes: function (data) {
    const body = {
      podids: data.podIds,
      labels: data.labels
    };

    if (data?.nodeIds && Array.isArray(data?.nodeIds) && data.nodeIds.length > 0) {
      body.nodeids = data.nodeIds;
      body.includeSubfolders = data?.includeSubfolders || false;
    }

    return API.post('pods/labels', body);
  },

  updateMlText: function(podID, itemId, payload) {
    return API.patch('pods/' + podID + '/mltexts/' + itemId, payload);
  },

  deleteMlText: function(podID, itemId) {
    return API.delete('pods/' + podID + '/mltexts/' + itemId);
  },
}
